export function SectionCornerTemplate(params) {
    return `<table class="esri-widget__table" summary="List of attributes and values">
          <tbody>
              <tr>
                  <th class="third">Township</th>
                  <td class="two-third">{Township}</td>
              </tr>
              <tr>
                  <th class="third">Range</th>
                  <td class="two-third">{Range}</td>
              </tr>
              <tr>
                  <th class="third">Section</th>
                  <td class="two-third">{Section_}</td>
              </tr>
              <tr>
                  <th class="third">Book</th>
                  <td class="two-third">{Book}</td>
              </tr>
              <tr>
                  <th class="third">Page</th>
                  <td class="two-third">{Page}</td>
              </tr>
              <tr>
                  <th class="third">Page</th>
                  <td class="two-third">
                      <a target="_blank" href="{Image}" class="ui fluid tiny button">View PDF</a>
                  </td>
              </tr>
          </tbody>
      </table>`;
  }
  